var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.isLink ? 'a' : 'span',_vm._b({tag:"component",staticClass:"proposal-number-link"},'component',
      _vm.isLink
        ? { href: _vm.linkForLot, target: '_blank', rel: 'noopener noreferrer' }
        : {}
    ,false),[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }